var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _mask, _g, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgMedicalConfirmation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 92,
    viewBox: "0 0 91 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 92,
    rx: 2,
    fill: "#D6E8F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 20,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 27,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 34,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 47,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 54,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.5512 29.1855L42.9687 70.768L49.8733 77.045L90.9989 35.9194L88.7704 33.5084L84.5512 29.1855Z",
    fill: "#3D83BB"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 29,
    width: 49,
    height: 49
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5512 29.1855L42.9687 70.768L49.8733 77.045L90.9989 35.9194L88.7704 33.5084L84.5512 29.1855Z",
    fill: "#3D83BB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.2036 34.7141L49.8734 77.0442L46.1072 73.9058L88.1677 31.8439L89.593 32.3031L92.2036 34.7141Z",
    fill: "#1E5D8F"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9695 70.768L37.3203 83.3219L49.8742 77.045L42.9695 70.768Z",
    fill: "#D7AE88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3203 83.3205L42.7605 80.6007L39.8524 77.6926L37.3203 83.3205Z",
    fill: "#2C3A64"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgMedicalConfirmation);
export default __webpack_public_path__ + "static/media/imgMedicalConfirmation.126125d9a1c33143179b38f40d3dbd7a.svg";
export { ForwardRef as ReactComponent };